import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Store from '../store/ProductionTableStore'
@observer
class SummationHeader extends Component {
    render() {     
        let header = '';
        if (Store.filters.selects.groupBy.selected) {
            header = Store.filters.selects.groupBy.selected.value === 'production' ? 'Produktion' : 'Leverans'
        }

        return <div className="production-table__summation">
            <h2 className="production-table__title">{ header }</h2>
            
            <div className="production-table__summation--right">
                <span className="production-table__summation__label">Summering</span>
                <ul className="production-table__summation__list">
                    <li className="production-table__summation__list__item">
                        Ordrar: { Store.orderSummation.orders } st
                    </li>
                    <li className="production-table__summation__list__item">
                        Ordervärde: { Store.orderSummation.value }
                    </li>
                    <li className="production-table__summation__list__item" title="Tim/Min">
                        Prod. tid: { Store.orderSummation.productionTime }
                    </li>
                    <li className="production-table__summation__list__item" title="Tim/Min">
                        Rest. tid: { Store.orderSummation.remainingTime }
                    </li>
                    <li className="production-table__summation__list__item">
                        Kvar: { Store.orderSummation.totalPercentile }%
                    </li>
                </ul>
            </div>
        </div>
    }
}

export default SummationHeader
